import { MenuStore, MenuItem } from "../domain/menu.interface";
import { create } from "zustand";
import { matchPath } from "react-router-dom";

const normalize = (p: string) => p?.replace(/\/+$/, "") || "";
const isMatch = (pattern: string, pathname: string, end: boolean) => {
  const route = normalize(pattern);
  const path = normalize(pathname);
  return !!matchPath({ path: route, end }, path);
};

const updateActiveState = (
  menuItems: MenuItem[],
  pathname: string
): MenuItem[] => {
  const path = normalize(pathname);
  return menuItems.map((item) => {
    const updatedChildren = item.children ? updateActiveState(item.children, path) : [];
    const isItemActive =
      item.type === "parent"
        ? isMatch(item.route, pathname, true)
        : isMatch(item.route, pathname, true);

    const hasActiveChild = updatedChildren.some((c) => c.active);
    return {
      ...item,
      active: isItemActive || hasActiveChild,
      open: item.type === "parent" && hasActiveChild ? true : item.open,
      children: updatedChildren,
    };
  });
};

export const useMenuStore = create<MenuStore>()((set) => ({
  menuItems: [],
  isLoading: true,
  addMenuItem: (item) =>
    set((state) => ({ menuItems: [...state.menuItems, item] })),
  setMenuItems: (items) => set({ menuItems: items, isLoading: false }),
  toggleOpen: (id) =>
    set((state) => ({
      menuItems: state.menuItems.map((item) =>
        item.id === id ? { ...item, open: !item.open } : item
      ),
    })),
  setActive: (pathname) =>
    set((state) => {
      const updatedMenu = updateActiveState(state.menuItems, pathname);
      return {
        menuItems: updatedMenu,
      };
    }),
}));
